import { Menu, Group, Text } from "@mantine/core";
import { IconLanguage, IconChevronDown } from "@tabler/icons-react";
import { useTranslationService } from "../hooks/useTranslationService";
import { useSearchParams } from "react-router-dom";
import { LANGUAGE_NATIVE_NAMES } from "../utils/languageNames";

const LanguageSwitcher = ({
  event,
  triggerStyle,
  dropdownStyle,
  itemStyle,
  ...props
}) => {
  const { language, changeLanguage } = useTranslationService();

  const [, setSearchParams] = useSearchParams();

  const eventLanguages = [
    event?.language,
    ...(event?.secondaryLanguages || []),
  ].filter(Boolean);

  const filteredLanguages = eventLanguages.map((code) => ({
    code,
    nativeName: LANGUAGE_NATIVE_NAMES[code] || code.toUpperCase(),
  }));

  if (filteredLanguages.length < 2) {
    return null;
  }

  const currentLanguage = filteredLanguages.find(
    (lang) => lang.code === language
  );

  const handleLanguageChange = (langCode) => {
    setSearchParams((params) => {
      params.set("lang", langCode);
      return params;
    });

    changeLanguage(langCode);
  };

  return (
    <Menu shadow="md" width={200} {...props}>
      <Menu.Target>
        <Group
          gap="xs"
          style={{
            cursor: "pointer",
            padding: "8px 12px",
            backgroundColor: "rgba(255, 255, 255, 0.15)",
            border: "1px solid rgba(255, 255, 255, 0.3)",
            borderRadius: "8px",
            color: "white",
            ...triggerStyle,
          }}
        >
          <IconLanguage size={20} />
          <Text size="sm" style={{ fontWeight: 500 }}>
            {currentLanguage?.nativeName || language.toUpperCase()}
          </Text>
          <IconChevronDown size={16} />
        </Group>
      </Menu.Target>

      <Menu.Dropdown
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.2)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.3)",
          ...dropdownStyle,
        }}
      >
        {filteredLanguages.map((lang) => (
          <Menu.Item
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            style={{
              fontWeight: language === lang.code ? 600 : 400,
              color: "white",
              backgroundColor:
                language === lang.code
                  ? "rgba(255, 255, 255, 0.2)"
                  : "transparent",
              ...itemStyle,
            }}
          >
            {lang.nativeName}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};

export default LanguageSwitcher;
